import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { DownloadDialogProps } from "src/interfaces/functionalComponentInterface";
import { generatePDF } from "src/helper/generatePDF";
import { Input } from "./ui/input";

const DownloadDialog: React.FC<DownloadDialogProps> = ({
  isOpen,
  setIsOpen,
  chartRef,
  detailData,
  totalClients,
  totalAccountValue,
  numberOfWeeks,
  weeksData,
  plotData,
  userName,
  startDate,
  lastDate,
}) => {
  const [name, setName] = useState<string>("");

  useEffect(() => {
    if (userName) {
      setName(userName);
    }
  }, [userName]);

  const handleDownload = async () => {
    try {
      await generatePDF(
        chartRef,
        detailData,
        totalClients,
        totalAccountValue,
        numberOfWeeks,
        weeksData,
        plotData,
        name,
        startDate,
        lastDate
      );
    } catch (e) {
      console.error("Error generating PDF:", e);
    } finally {
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button className="w-full bg-secondary text-xs md:text-sm font-medium transition-all btn-inset-shadow duration-400 ease-in-out group rounded-sm text-[#FCFDFE] hover:bg-[#526F70]">
          <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-tertiary group-hover:stroke-white transition-all duration-400 ease-in-out"
          >
            <path
              d="M19 13.073V17.073C19 17.6034 18.7893 18.1121 18.4142 18.4872C18.0391 18.8623 17.5304 19.073 17 19.073H3C2.46957 19.073 1.96086 18.8623 1.58579 18.4872C1.21071 18.1121 1 17.6034 1 17.073V13.073"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5 8.073L10 13.073L15 8.073"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10 13.073V1.073"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Download Report
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[90vw] md:max-w-lg w-full p-4 md:p-6 rounded-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base md:text-lg font-title">
            Download Report
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          <div>
            <p className="text-sm text-gray-600 mb-2">
              Please confirm the name that will be displayed on the report.
            </p>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-tertiary"
              placeholder="Enter your name"
            />
          </div>
          <Button
            className="w-full mt-4 text-white bg-primary hover:bg-primary-foreground font-medium py-2 rounded-md transition-all"
            onClick={handleDownload}
          >
            Confirm & Download
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadDialog;
